﻿<div class="scrollable" [ngClass]="{horizontal: horizontal}">
  <div class="scrollable-inner">
    <ng-content></ng-content>
  </div>
</div>